'use strict';
var _ = require('underscore');

var componentRenderLogs = {};
var pageRenderLogs = {};
var pageReadLogs = {};

var callbacks = [];
var timer = null;

function notify() {
  if (!window.debug) {
    return;
  }
  clearTimeout(timer);
  timer = setTimeout(function () {
    var sortedComponentRenderLogs = sortLogsByAverageTime(componentRenderLogs);
    var sortedPageRenderLogs = sortLogsByAverageTime(pageRenderLogs);
    var sortedPageReadLogs = sortLogsByTime(pageReadLogs);
    _.each(callbacks, function (cb) {
      cb(sortedComponentRenderLogs, sortedPageRenderLogs, sortedPageReadLogs);
    });
  }, 100);
}

function sortLogsByAverageTime(arr) {
  var res = [];
  _.each(arr, function (v, k) {
    res.push([k, v.count, Math.floor(v.time / v.count), v.name]);
  });
  return res.sort(function (a, b) {
    return b[2] - a[2];
  });
}

function sortLogsByTime(arr) {
  var res = [];
  _.each(arr, function (v, k) {
    res.push([k, v.count, v.time, v.name]);
  });
  return res.sort(function (a, b) {
    return b[2] - a[2];
  });
}

exports.reset = function () {
  componentRenderLogs = {};
  pageRenderLogs = {};
  pageReadLogs = {};
  notify();
};

exports.addCallback = function (cb) {
  callbacks.push(cb);
};

exports.removeCallback = function (cb) {
  callbacks.splice(callbacks.indexOf(cb), 1);
};

exports.logComponentRender = function (controlTypeID, time) {
  if (!window.debug) {
    return;
  }
  if (componentRenderLogs[controlTypeID]) {
    componentRenderLogs[controlTypeID].time = componentRenderLogs[controlTypeID].time + time;
    componentRenderLogs[controlTypeID].count++;
  } else {
    componentRenderLogs[controlTypeID] = {
      time: time,
      count: 1
    };
  }
  notify();
};

exports.logPageRender = function (pageID, pageName, time) {
  if (!window.debug) {
    return;
  }
  if (!pageRenderLogs[pageID]) {
    pageRenderLogs[pageID] = {
      name: pageName,
      time: 0,
      count: 0
    };
  }
  pageRenderLogs[pageID].time += time;
  pageRenderLogs[pageID].count++;
  notify();
};

exports.logPageRead = function (pageID, pageName, time) {
  if (!window.debug) {
    return;
  }
  if (!pageReadLogs[pageID]) {
    pageReadLogs[pageID] = {
      name: pageName,
      time: 0,
      count: 0
    };
  }
  if (time > pageReadLogs[pageID].time) {
    pageReadLogs[pageID].time = time;
  }
  pageReadLogs[pageID].count++;
  notify();
};



// WEBPACK FOOTER //
// ./src/helper/timeLogHelper.js